var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivityReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.004,
    height: 13,
    viewBox: "0 0 13.004 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Activity_Report",
    "data-name": "Activity Report",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M110.861,56.924c0-1.093,0-2.187,0-3.28a1.7,1.7,0,0,1,.684-1.414,1.445,1.445,0,0,1,.905-.33c1.893,0,3.788-.005,5.683,0a1.54,1.54,0,0,1,1.209.62,1.742,1.742,0,0,1,.391,1.136q0,1.425,0,2.85c0,.133,0,.13-.128.147s-.256.038-.385.057c-.1.015-.107.008-.107-.093V53.664a1.156,1.156,0,0,0-.283-.791,1,1,0,0,0-.767-.362c-.422-.006-.844,0-1.266,0-1.4,0-2.809.006-4.213,0a1.1,1.1,0,0,0-1.109,1.1q-.007,3.316,0,6.633a1.111,1.111,0,0,0,.762,1.052,1.061,1.061,0,0,0,.336.047h2.914c.134,0,.132,0,.14.134a3.03,3.03,0,0,0,.051.378c.019.1.01.108-.091.108H112.6a1.7,1.7,0,0,1-1.644-1.147,1.523,1.523,0,0,1-.095-.524q0-1.681,0-3.361Z",
    transform: "translate(-110.86 -51.898)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M348.544,285.816A3.556,3.556,0,1,1,345,282.268,3.547,3.547,0,0,1,348.544,285.816Zm-.611.013a2.939,2.939,0,1,0-2.949,2.925A2.93,2.93,0,0,0,347.933,285.828Z",
    transform: "translate(-335.541 -276.375)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M205.042,166.927h1.745a.3.3,0,0,1,.323.355.27.27,0,0,1-.177.233.484.484,0,0,1-.191.032h-3.417a.36.36,0,0,1-.281-.1.292.292,0,0,1-.062-.323.281.281,0,0,1,.259-.193c.1-.007.2,0,.309,0Z",
    transform: "translate(-200.603 -163.982)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M205.087,236.76H203.31a.29.29,0,0,1-.279-.2.314.314,0,0,1,.089-.34.357.357,0,0,1,.243-.073h3.457a.36.36,0,0,1,.223.06.313.313,0,0,1,.109.356.293.293,0,0,1-.288.195Z",
    transform: "translate(-200.655 -231.436)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M204.8,305.217h1.452c.03,0,.072-.015.088.021s-.02.053-.037.077a3.971,3.971,0,0,0-.3.454.125.125,0,0,1-.125.07h-2.507a.315.315,0,0,1-.335-.312.3.3,0,0,1,.333-.309Q204.088,305.216,204.8,305.217Z",
    transform: "translate(-200.682 -298.734)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M463.82,345.122c0,.251,0,.5,0,.755a.242.242,0,0,0,.078.192c.358.353.713.71,1.068,1.066a.308.308,0,0,1,.084.355.3.3,0,0,1-.509.093c-.317-.314-.631-.63-.947-.945l-.288-.286a.314.314,0,0,1-.1-.233q0-.889,0-1.777a.3.3,0,0,1,.306-.318.295.295,0,0,1,.3.3c0,.265,0,.53,0,.8Z",
    transform: "translate(-454.194 -336.551)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityReport);
export default __webpack_public_path__ + "static/media/activity-report.b990f9c076ae68c777441700c8685a16.svg";
export { ForwardRef as ReactComponent };